/**
 * Created by Darius on 2017.04.02.
 */
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import auth from './reducers/auth';
import common from './reducers/common';
import dashboard from './reducers/dashboard';
import roles from './reducers/roles';
import templates from './reducers/templates';
import members from './reducers/members';
import feedSources from './reducers/feed-sources';
import chatArchive from './reducers/chat-archive';

export default combineReducers({
    form: formReducer,
    common,
    auth,
    dashboard,
    roles,
    templates,
    members,
    feedSources,
    chatArchive
});